import { log } from '@spa/log'
import { loadAtoneScript } from '@spa/services/atone'
import { loadPaidyScript } from '@spa/services/paidy'
import { none, Option, some } from 'fp-ts/lib/Option'

class PaymentScriptLoadState {
  static init(): PaymentScriptLoadState {
    return new PaymentScriptLoadState(false)
  }

  private constructor(readonly loaded: boolean) {}

  loadedScript(): PaymentScriptLoadState {
    return new PaymentScriptLoadState(true)
  }
}

export interface PaymentScriptLoader {
  readonly loaded: boolean
  readonly loadErrorMessage: string
  loadScript(): Promise<Option<Error>>
}

abstract class AbstractPaymentScriptLoader implements PaymentScriptLoader {
  abstract readonly loadErrorMessage: string
  protected loadState: PaymentScriptLoadState = PaymentScriptLoadState.init()

  get loaded(): boolean {
    return this.loadState.loaded
  }

  abstract loadScript(): Promise<Option<Error>>
}

export class AtoneScriptLoader extends AbstractPaymentScriptLoader {
  readonly loadErrorMessage = 'エラーが発生したためatoneがご利用できません。<br/>※少し時間をおいてお試しいただくか、改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'

  async loadScript(): Promise<Option<Error>> {
    if (this.loaded) return none

    try {
      await loadAtoneScript()
      if (!Atone) throw new Error('could not load atone script')

      this.loadState = this.loadState.loadedScript()

      return none
    } catch (e) {
      const errorMessage = 'error on loading atone script'
      log.error(errorMessage, e)

      return some(new Error(errorMessage))
    }
  }
}

export class PaidyScriptLoader extends AbstractPaymentScriptLoader {
  readonly loadErrorMessage = 'エラーが発生したためPaidyがご利用できません。<br/>※少し時間をおいてお試しいただくか、改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'

  async loadScript(): Promise<Option<Error>> {
    if (this.loaded) return none

    try {
      await loadPaidyScript()
      if (!Paidy) throw new Error('could not load paidy script')

      this.loadState = this.loadState.loadedScript()

      return none
    } catch (e) {
      const errorMessage = 'error on loading paidy script'
      log.error(errorMessage, e)

      return some(new Error(errorMessage))
    }
  }
}
